const NL_LICENSE_PLATE_REGEXP = new RegExp(
  '^[a-zA-Z0-9]{0,6}$|' + // XXXXXX
    '^[a-zA-Z0-9]{1}-[a-zA-Z0-9]{0,3}$|^[a-zA-Z0-9]{1}-[a-zA-Z0-9]{3}-[a-zA-Z0-9]{0,2}$|' + // X-XXX-XX
    '^[a-zA-Z0-9]{2}-[a-zA-Z0-9]{0,2}$|^[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{0,2}$|' + // XX-XX-XX
    '^[a-zA-Z0-9]{2}-[a-zA-Z0-9]{3}$|[a-zA-Z0-9]{2}-[a-zA-Z0-9]{3}-[a-zA-Z0-9]{0,1}$', // XX-XXX-X
);

export type TCountryValidation = {
  pattern: RegExp;
};

export type TValidationByCountryCode = {
  [key: string]: TCountryValidation;
};

export default {
  NL: {
    pattern: NL_LICENSE_PLATE_REGEXP,
  },
} as TValidationByCountryCode;
